import * as actions from './dataBackup/actions'
import * as mutations from './dataBackup/mutations'
import * as getters from './dataBackup/getters'

const state = {
    list: [],
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/dataBackup.js